import Image from 'next/image';

import { Icon } from 'common/icon';

import { Routes } from 'constants/routes';
import { IProvider } from 'constants/types';
import Link from 'next/link';

import clsx from 'clsx';
import styles from './styles.module.css';

export const CheckRtpBlock = ({
  id,
  title,
  provider,
  disableMargins,
}: {
  id?: string;
  title?: string;
  provider: IProvider | null;
  disableMargins?: boolean;
}) => {
  return (
    <section
      id={id}
      className={clsx(styles['check-rtp'], {
        [styles.container_without_margin]: disableMargins,
      })}
    >
      <div
        className={clsx(styles.container_s, {
          [styles.container_without_margin]: disableMargins,
        })}
      >
        <div className={styles['check-rtp__wrapper']}>
          {title && (
            <h2 className={styles['check-rtp__title']}>
              {title + ' ' + `how to check RTP`}
            </h2>
          )}
          {provider?.link ? (
            <Link
              href={Routes.guidePage(provider.link)}
              className={styles['check-rtp__link']}
            >
              {provider?.imageUrl && (
                <div className={styles['check-rtp__link-logo']}>
                  <Image
                    alt="slot"
                    height={50}
                    width={160}
                    src={provider.imageUrl}
                    style={{ width: 'auto', height: '50px' }}
                  />
                </div>
              )}
              <div className={styles['check-rtp__link-text']}>
                <Icon.ReadPost fill="white" />
                <span>{`How to check RTP at ${provider?.name} Provider?`}</span>
              </div>
              <div className={styles['check-rtp__link-arrow']}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                  fill="none"
                >
                  <path
                    d="M13.0605 23.5605L21.621 15L13.0605 6.43951L10.9395 8.56051L17.379 15L10.9395 21.4395L13.0605 23.5605Z"
                    fill="white"
                    fillOpacity="0.4"
                  />
                </svg>
              </div>
            </Link>
          ) : null}
        </div>
      </div>
    </section>
  );
};
